module.exports = __webpack_public_path__ + "static/media/ruble-sign.07a5c6e5.svg";